<template>
    <v-container>
        <v-layout row class="text-xs-center">
            <v-flex xs0 md2 lg3 xl4>
            </v-flex>
            <v-flex xs12 md8 lg6 xl4 id="login-container-flex">
                <v-container style="position: relative;top: 13%;" class="text-xs-center" id="login-container-flex-container">
                    <img src="/fatel.svg" style="max-height: 200px; max-width: 200px;" />
                    <v-card flat id="login-container-flex-container-vcard">
                        <v-card-title primary-title>
                            <h4>Cambia la tua password:</h4>
                        </v-card-title>
                        <v-form @submit="doChangePassword" v-on:submit.prevent>
                            <v-text-field readonly prepend-icon="person" name="Username" label="Nome Utente" v-model="username"></v-text-field>
                            <v-text-field prepend-icon="lock" name="Password" label="Nuova Password" type="password" v-model="password"></v-text-field>

                            <v-alert v-model="alert" :type="alertType" id="login-container-flex-container-vcard-alert">{{alertText}}</v-alert>
                            <v-card-actions id="login-container-flex-container-vcard-actions">
                                <v-btn autofocus primary large block type="submit" id="login-container-flex-container-vcard-actions-login">
                                    Cambia
                                </v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-container>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import AuthApi from '@/api/auth.js'

    export default {
        name: 'ChangePassword',
        data: () => ({
            guid:'',
            username: '',
            password: '',
            alertText:'',
            alert: false,
            alertType:'success',
        }),
        computed: {
        },
        mounted() {
            this.$store.state.globalHeader = false;
            this.$store.state.globalDrawer = false;
        },
        created() {
            this.guid = this.$route.query.guid;
            AuthApi.getResetPasswordRequest(this.guid)
                .then(t => {
                    this.username = t.data.Username;
                });
        },
        methods: {
            doChangePassword() {
                this.alert = false;
                AuthApi.doChangePassword(this.username, this.password)
                    .then(() => {
                        window.alert('Password modificata correttamente!');
                        this.$router.push('login');
                    })
                    .catch(t => {
                        this.alertText = t.response.data;
                        this.alertType = 'error';
                        this.alert = true;
                    });
            },
        },
    }
</script>
